<template>
  <div class="photo-picture text-center">
    <img :src="imageSource" ref="photoImg" class="photoImg" alt="Foto" />

    <b-button
      v-if="!isEditing"
      class="xlarge mt-5"
      v-b-modal="`edit-photo-${modalId}`"
    >
      <UploadIcon />
    </b-button>

    <b-button v-else class="xlarge outline" v-b-modal="`edit-photo-${modalId}`"
      >Editar foto</b-button
    >

    <EditPhotoProfile :modalId="modalId" v-bind="$attrs" />
  </div>
</template>

<script>
import UploadIcon from "@/components/svg/UploadIcon.vue";
import EditPhotoProfile from "@/components/modals/EditPhotoProfile.vue";

export default {
  name: "ProfilePhoto",
  props: {
    isEditing: {
      type: Boolean,
      default: false,
    },
    modalId: {
      type: String,
      default: "1",
    },
  },

  components: {
    UploadIcon,
    EditPhotoProfile,
  },

  data() {
    return {
      objectUrl: null,
    };
  },

  computed: {
    photo() {
      return this.$attrs.photo;
    },

    imageSource() {
      const photo = this.photo;
      if (!photo) {
        return require("@/assets/images/user_placeholder.png");
      }

      if (typeof photo === "string") {
        return photo;
      }

      if (
        typeof photo === "object" &&
        (photo instanceof File || photo instanceof Blob)
      ) {
        if (this.objectUrl) {
          return this.objectUrl;
        } else {
          return require("@/assets/images/user_placeholder.png");
        }
      }

      return require("@/assets/images/user_placeholder.png");
    },
  },

  watch: {
    photo: {
      handler(newPhoto) {
        if (this.objectUrl) {
          URL.revokeObjectURL(this.objectUrl);
          this.objectUrl = null;
        }

        if (
          newPhoto &&
          typeof newPhoto === "object" &&
          (newPhoto instanceof File || newPhoto instanceof Blob)
        ) {
          const urlCreator = window.URL || window.webkitURL;
          this.objectUrl = urlCreator.createObjectURL(newPhoto);
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
      },
      immediate: true,
    },
  },

  beforeDestroy() {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.photoImg {
  width: 100%;
}

.photo-picture {
  background-color: $grey6;
  max-width: 305px;
  padding: 40px 20px;

  .btn {
    svg {
      fill: $white;
    }
    &:hover {
      svg {
        fill: $grey4;
      }
    }
    &.outline {
      margin-top: 24px;
    }
  }
  .btn-rotate {
    margin-bottom: 26px;
    svg {
      margin: 20px 10px 0;
      &:last-child {
        transform: rotateY(180deg);
      }
    }
  }
}
</style>
